import { useEffect, useState } from 'react'
import { VscClose } from 'react-icons/vsc'

import './imageModal.scss'

type ImageModalProps = {
  isOpen: boolean
  imageSrc: string
  imageAlt: string
  onClose: () => void
  imageThumbnail?: string
}

function ImageModal(props: Readonly<ImageModalProps>) {
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  useEffect(() => {
    if (props.isOpen) {
      document.body.style.overflow = 'hidden'
      setIsImageLoaded(false) // Reset beim Öffnen
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [props.isOpen, props.imageSrc])

  if (!props.isOpen) return null

  return (
    <div className='comp-imageModal' onClick={props.onClose}>
      <div className='imageModal-overlay' />
      <button className='imageModal-close' onClick={props.onClose} aria-label="Close modal">
        <VscClose />
      </button>
      <div className='imageModal-content'>
        {/* Zeige Thumbnail während des Ladens */}
        {!isImageLoaded && props.imageThumbnail && (
          <div className='imageModal-thumbnail'>
            <img src={props.imageThumbnail} alt="" className='thumbnail-blur' />
          </div>
        )}

        {/* Lade das hochauflösende Bild */}
        <img
          src={props.imageSrc}
          alt={props.imageAlt}
          className={`imageModal-mainImage ${isImageLoaded ? 'imageModal-mainImage--loaded' : 'imageModal-mainImage--loading'}`}
          onLoad={() => setIsImageLoaded(true)}
        />
      </div>
    </div>
  )
}

export default ImageModal
